import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GroupDepartmentSettings from './GroupDepartmentSettings';
import GroupTabSettings from './GroupTabSettings';
import { setCurrentTab } from '../../actions/apiSetInfo';

const GroupSettingsBody = () => {
  const dispatch = useDispatch();
  const current_tab = useSelector((state) => state.settings_admin.current_tab);

  const onTabClick = useCallback(
    (tabName) => {
      dispatch(setCurrentTab(tabName));
    },
    [dispatch],
  );

  return (
    <div className="col">
      <ul className="nav nav-pills nav-fill bg-light pad-bottom-1" role="tablist">
        <li className="nav-item">
          <a
            className={current_tab === 'group-tab-defaults' ? 'nav-link active' : 'nav-link'}
            name="group-tab-defaults"
            onClick={() => onTabClick('group-tab-defaults')}
          >
            Tab Defaults
          </a>
        </li>
        <li className="nav-item">
          <a
            className={current_tab === 'group-departments' ? 'nav-link active' : 'nav-link'}
            name="group-departments"
            onClick={() => onTabClick('group-departments')}
          >
            Departments
          </a>
        </li>
        <li className="nav-item">
          <a
            className={current_tab === 'group-timedashboard' ? 'nav-link active' : 'nav-link text-muted'}
            name="group-timedashboard"
            onClick={() => onTabClick('group-timedashboard')}
          >
            TimeDashboard
          </a>
        </li>
        <li className="nav-item">
          <a
            className={current_tab === 'group-workflows' ? 'nav-link active' : 'nav-link text-muted'}
            name="group-workflows"
            onClick={() => onTabClick('group-workflows')}
          >
            WorkFlows
          </a>
        </li>
        <li className="nav-item">
          <a
            className={current_tab === 'group-users' ? 'nav-link active' : 'nav-link text-muted'}
            name="group-users"
            onClick={() => onTabClick('group-users')}
          >
            Users
          </a>
        </li>
        <li className="nav-item">
          <a
            className={current_tab === 'group-default-settings' ? 'nav-link active' : 'nav-link text-muted'}
            name="group-default-settings"
            onClick={() => onTabClick('group-default-settings')}
          >
            Default Settings
          </a>
        </li>
      </ul>
      <div className="container-fluid pad-left-0 pad-right-0 bg-light">
        <div className={current_tab === 'group-tab-defaults' ? 'tab-box active' : 'tab-box'}>
          <GroupTabSettings />
        </div>
        <div className={current_tab === 'group-departments' ? 'tab-box active' : 'tab-box'}>
          <GroupDepartmentSettings />
        </div>
        <div className={current_tab === 'group-timedashboard' ? 'tab-box active' : 'tab-box'}>
          <div className="text-center text-muted p-4">
            <h4>Coming Soon</h4>
            <p>This feature is under development and will be available soon.</p>
          </div>
        </div>
        <div className={current_tab === 'group-workflows' ? 'tab-box active' : 'tab-box'}>
          <div className="text-center text-muted p-4">
            <h4>Coming Soon</h4>
            <p>This feature is under development and will be available soon.</p>
          </div>
        </div>
        <div className={current_tab === 'group-users' ? 'tab-box active' : 'tab-box'}>
          <div className="text-center text-muted p-4">
            <h4>Coming Soon</h4>
            <p>This feature is under development and will be available soon.</p>
          </div>
        </div>
        <div className={current_tab === 'group-default-settings' ? 'tab-box active' : 'tab-box'}>
          <div className="text-center text-muted p-4">
            <h4>Coming Soon</h4>
            <p>This feature is under development and will be available soon.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupSettingsBody;